var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzAzerbaijan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_7649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9902 0H-0.00976562V45H59.9902V0Z",
    fill: "#3F9C35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9902 0H-0.00976562V30H59.9902V0Z",
    fill: "#ED2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9902 0H-0.00976562V15H59.9902V0Z",
    fill: "#00B9E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 29.25C27.7721 29.25 24.75 26.2279 24.75 22.5C24.75 18.7721 27.7721 15.75 31.5 15.75C35.2279 15.75 38.25 18.7721 38.25 22.5C38.25 26.2279 35.2279 29.25 31.5 29.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 28.125C26.8934 28.125 24.375 25.6066 24.375 22.5C24.375 19.3934 26.8934 16.875 30 16.875C33.1066 16.875 35.625 19.3934 35.625 22.5C35.625 25.6066 33.1066 28.125 30 28.125Z",
    fill: "#ED2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 18.75L23.2781 20.7656L21.3469 19.8469L22.2656 21.7875L20.25 22.5L22.2656 23.2219L21.3469 25.1531L23.2781 24.2344L24 26.25L24.7219 24.2344L26.6531 25.1531L25.7344 23.2219L27.75 22.5L25.7344 21.7781L26.6531 19.8469L24.7219 20.7656L24 18.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_7649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzAzerbaijan);
export default __webpack_public_path__ + "static/media/az Azerbaijan.c8d3376ebc3bb5a3f4c90fef6bd31921.svg";
export { ForwardRef as ReactComponent };